
/* ===== VELANTIS_PRIVE — página del club Privé ===== */
(function(){
  function route(){
    var isP=/^#\/prive\/?$/.test(location.hash||'');
    document.body.classList.toggle('prive',isP);
    var p=document.getElementById('privePage'); if(p)p.hidden=!isP;
    if(isP) window.scrollTo(0,0);
  }
  window.addEventListener('hashchange',route);
  if(document.readyState!=='loading') route(); else document.addEventListener('DOMContentLoaded',route);
})();
